<template>
    <div class="animated fadeIn paymentVoucherDetail bgV2">
        <b-row class="p-20 pr-4">
            <b-col md="12">
                <div class="d-flex headerComponent justify-content-between align-items-end" v-if="$route.params.id != 0">
                    <h3 class="title">{{item ? item.ld_number:''}}</h3>
                    <span class="status mr-3">{{item ? item.status:''}}</span>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                                @click="save(2)"
                                :disabled="($route.params.id != 0 && !$checkRole($accessModule.liquidated_damages, 'update')) || $route.params.id == 0 || !!item.payment_voucher || item.status === 'Cancelled'"
                                class="mr-3"
                                label="Cancel"></gofix-button>
<!--                        <gofix-button-->
<!--                                @click="save(3)"-->
<!--                                :disabled="!!item.payment_voucher || item.status !== 'Draft'"-->
<!--                                class="mr-3"-->
<!--                                label="Submit & Raise PV"></gofix-button>-->
                        <gofix-button
                                :disabled="($route.params.id != 0 && !$checkRole($accessModule.liquidated_damages, 'update')) || $route.params.id == 0 || !!item.payment_voucher || item.status !== 'Draft' || item.status === 'Submitted'"
                                @click="save(1)"
                                class="mr-3"
                                label="Submit"></gofix-button>
                        <gofix-button
                                :disabled="($route.params.id == 0 && !$checkRole($accessModule.liquidated_damages, 'create')) || ($route.params.id != 0 && !$checkRole($accessModule.liquidated_damages, 'update')) || (item.status === 'Cancelled' && $route.params.id != 0 ) ||  !!item.payment_voucher"
                                @click="save"
                                class=""
                                label="Save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <ld-info></ld-info>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <ld-activities ref="ldActivities" activityType="Liquidated Damages" :activityId="$route.params.id"></ld-activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    const ldActivities = () => import("../../global/Activities")
    const ldInfo = () => import("./detail-info")
    import moment from 'moment';

    export default {
        name: 'liquidated-damages-detail',
        components: {
            ldInfo,
            ldActivities
        },
        data() {
            return {
                tabData: this.$route.params.id != 0 ? [
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                ] : [
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    }
                ],
            }
        },
        computed: {
            ...mapGetters({
                item: "LiquidatedDamagesController/item",
                UserLogged : 'AuthController/user'
            }),
        },
        async created() {
            this.getLiquidatedDamage();
        },
        watch: {
            "$route.params.id": function(val, old){
                if(val) {
                    this.tabData = [
                        {
                            key: "basic-info",
                            title: "Basic Info",
                            active: true
                        },
                        {
                            key: "activity-log",
                            title: "Activity Log",
                            active: false
                        },
                    ]
                }
            }
        },
        methods: {
            /*------ Get data -----------------------------------*/
            getLiquidatedDamage(){
                if(this.$route.params.id != 0){
                    this.$store.dispatch('LiquidatedDamagesController/getItem', this.$route.params.id)
                        .then(response => {
                            this.item.ld_date = this.item.ld_date ? new Date(this.item.ld_date) : new Date();
                            this.item.issue_date_budget = this.item.issue_date_budget ? new Date(this.item.issue_date_budget) : null;
                            this.item.total = this.$accounting.formatMoney(this.item.total, { format: {
                                pos : "%s %v",
                                neg : "%s (%v)",
                                zero: "%s %v"
                            }});
                            this.item.fm_code = Object.assign(this.item.fm_code, {
                                fm_code: this.item.fm_code_text ? this.item.fm_code_text : '',
                                description: this.item.fm_code_description ? this.item.fm_code_description : ''
                            })
                            this.item.gl_code = Object.assign(this.item.gl_code, {
                                gl_code: this.item.gl_code_text ? this.item.gl_code_text : '',
                                name: this.item.gl_code_description ? this.item.gl_code_description : '',
                            })
                        });
                }else{
                    this.$store.commit('LiquidatedDamagesController/resetItem');
                    this.item.created_at = this.item.created_at ? this.item.created_at : moment().format("YYYY-MM-DD");
                }
            },
            save(type = 0){
                //Check required fields
                if(!this.item.client_contract_id){
                    return this.$alertNotification("Contract is a required field.", "danger");
                }
                if(!this.item.supplier){
                    return this.$alertNotification("Please select a supplier", "danger");
                }
                if(this.item.contract.settings && this.item.contract.settings.is_required_gl_code && !this.item.gl_code_id) {
                    return this.$alertNotification("GL Code is a required field.", "danger");
                }
                if(this.item.contract.settings && this.item.contract.settings.is_required_fm_code && !this.item.fm_code_id) {
                    return this.$alertNotification("FM Code is a required field.", "danger");
                }
                
                let action = "createItem";
                let noti = "adding";
                if(this.$route.params.id != 0){
                    action = "updateItem";
                    noti = "editing";
                }

                let data = JSON.parse(JSON.stringify(this.item));
                data.status = type === 1 ?  "Submitted" : data.status;
                data.total = this.$accounting.unformat(data.total);
                data.ld_date =data.ld_date ? moment(new Date(data.ld_date)).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
                data.issue_date_budget = data.issue_date_budget ? moment(data.issue_date_budget).format("YYYY-MM-DD") : null;

                switch (type) {
                    case 1:
                        data.status = "Submitted";
                        break;
                    case 2:
                        data = {
                            id: data.id,
                            status: "Cancelled"
                        };
                        break;
                    default:
                        data.status = "Draft";
                        break;
                }

                this.$store.dispatch(`LiquidatedDamagesController/${action}`,data)
                    .then((response) => {
                        if(type === 3){
                            this.raisePV(response);
                        }else{
                            this.$alertNotification(this.$notificationV2(noti, 'liquidated_damages'));
                            this.item.ld_date = this.item.ld_date ? new Date(this.item.ld_date) : new Date();
                            this.item.issue_date_budget = this.item.issue_date_budget ? new Date(this.item.issue_date_budget) : null;
                            this.item.total = this.$accounting.formatMoney(this.item.total, { format: {
                                    pos : "%s %v",
                                    neg : "%s (%v)",
                                    zero: "%s %v"
                                }});
                            if(this.$route.params.id == 0){
                                this.$router.push({name:"liquidated-damages-detail",params:{id:response.id}});
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            raisePV(data){
                let request = {
                    pv_date : moment(new Date()).format('YYYY-MM-DD'),
                    status : 'Under Approval',
                    pay_to_type : "Supplier",
                    client_contract_id : data.client_contract_id,
                    liquidated_damages_ids : [data.id],
                    from_raise  : "LD",
                    pay_to_id : data.supplier_id
                };

                this.$store.dispatch(`PaymentVoucherController/createPayment`, request)
                    .then(async (response) => {
                        await this.$alertNotification(this.$notificationV2('adding', 'payment_voucher'));
                        await this.$router.push('/v2/payment-voucher/' + response.data.data.id)
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
        }
    }
</script>
